(function () {
    'use strict';

    angular
        .module('app.postScore')
        .constant('golferScorePostingResolver', {
            data: getData
        });

    getData.$inject = ['$transition$', '$q', 'user', 'Score'];
    function getData($transition$, $q, user, Score) {
        var params = $transition$.params(),
            individualId = params.individualId || user.id,
            teeTimeId = params.teeTimeId || null,           
            courseId = params.courseId || null,
            playDate = params.playDate || null,
            allowScorePosting = user.allowScorePosting,
            scoreId = params.scoreId;

        if (!allowScorePosting) 
            return $q.reject('Score Posting Disallowed!');
        return Score.getScoreData({ individualId: individualId, scoreId: scoreId, teeTimeId: teeTimeId, courseId: courseId, playDate: playDate }, true).$promise;
    }
})();